
<mat-card class="matcardcontent">
    <mat-card-header>
        <mat-card-title>Lista azioni</mat-card-title>
    </mat-card-header>
    <mat-card-content>



           <mat-form-field appearance="fill" style="padding-right: 10px">
             <mat-label class="text-sm">Utente</mat-label>
             <mat-select [(ngModel)]="selectedValueUser" name="user" (selectionChange)="manageChangeUser()" class="text-sm">
               <mat-option *ngFor="let user of users" [value]="user.Username">
                 {{user.Username}}
               </mat-option>
             </mat-select>
           </mat-form-field>

           <mat-form-field appearance="fill" style="padding-right: 10px">
             <mat-label class="text-sm">Commessa</mat-label>
             <mat-select [(ngModel)]="selectedValueCommessa" name="commessa" (selectionChange)="manageChangeCommessa()" class="text-sm">
               <mat-option *ngFor="let commessa of commesse" [value]="commessa.Numerocommessa">
                 {{commessa.Numerocommessa}}
               </mat-option>
             </mat-select>
           </mat-form-field>

           <mat-form-field class="text-sm" style="padding-right: 10px">
                     <mat-label class="text-sm">Data inizio</mat-label>
                     <input matInput [matDatepicker]="startpicker"
                       placeholder="Data inizio"
                       [(ngModel)]="selectedValueDatainizio"
                       (dateChange)="onFiltroDatainizioDatechange($event)">
                     <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                     <mat-datepicker #startpicker startView="month" ></mat-datepicker>
           </mat-form-field>

           <mat-form-field class="text-sm" style="padding-right: 10px">
                     <mat-label class="text-sm">Data fine</mat-label>
                     <input matInput [matDatepicker]="endpicker"
                       placeholder="Data fine"
                       [(ngModel)]="selectedValueDatafine">
                     <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
                     <mat-datepicker #endpicker startView="month" ></mat-datepicker>
           </mat-form-field>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
<!--
    <ng-container matColumnDef="sel">
      <th mat-header-cell *matHeaderCellDef>Altro</th>
      <td mat-cell *matCellDef="let commessa">
            <mat-checkbox
              (click)="manageCheckboxclick($event, commessa)"
              (change)="$event ? selection.toggle(commessa) : null"
              [checked]="selection.isSelected(commessa)">
            </mat-checkbox>
      </td>
    </ng-container>
-->
    <ng-container matColumnDef="Id">
        <th mat-header-cell *matHeaderCellDef>Id
          <img src="./assets/images/sort.png" (click)="manageClick('Id')"/>
        </th>
        <td  mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Id}} </td>
    </ng-container>

    <ng-container matColumnDef="Codicecommessa">
        <th mat-header-cell *matHeaderCellDef>Commessa
          <img src="./assets/images/sort.png" (click)="manageClick('Codicecommessa')"/>
        </th>
        <td mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Codicecommessa}} </td>
    </ng-container>

    <ng-container matColumnDef="Nomelavorazione">
        <th mat-header-cell *matHeaderCellDef>Lavorazione
          <img src="./assets/images/sort.png" (click)="manageClick('Nomelavorazione')"/>
        </th>
        <td mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Nomelavorazione}} </td>
    </ng-container>

    <ng-container matColumnDef="Statoiniziale">
        <th mat-header-cell *matHeaderCellDef>Stato iniziale
          <img src="./assets/images/sort.png" (click)="manageClick('Statoiniziale')"/>
        </th>
        <td  mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Statoiniziale}} </td>
    </ng-container>

    <ng-container matColumnDef="Statofinale">
        <th  mat-header-cell *matHeaderCellDef>Stato finale
          <img src="./assets/images/sort.png" (click)="manageClick('Statofinale')"/>
        </th>
        <td  mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Statofinale}} </td>
    </ng-container>

    <ng-container matColumnDef="Dataazione">
        <th  mat-header-cell *matHeaderCellDef>Data azione
          <img src="./assets/images/sort.png" (click)="manageClick('Dataazione')"/>
        </th>
        <td mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Dataazione | date: 'dd/MM/yyyy'}} </td>
    </ng-container>
     
    <ng-container matColumnDef="Timeazione">
        <th  mat-header-cell *matHeaderCellDef>Ora azione
          <img src="./assets/images/sort.png" (click)="manageClick('Timeazione')"/>
        </th>
        <td mat-cell *matCellDef="let orfriaudit"> {{orfriaudit.Timeazione}} </td>
    </ng-container>




      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
<!--      <td>
        <button mat-raised-button  color="primary" (click)="new()">Nuova commessa</button>
      </td>
-->      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
